import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles, Loader2, ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ClientLogin() {
  const { user, clientLogin } = useAuth();
  const navigate = useNavigate();
  const [whatsapp, setWhatsapp] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate(user.role === "admin" ? "/admin" : user.role === "livreur" ? "/driver" : "/", { replace: true });
  }, [user]); // eslint-disable-line

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      if (password.length < 8) {
        setError("Le mot de passe doit contenir au moins 8 caractères.");
        setLoading(false);
        return;
      }
      await clientLogin(whatsapp, password);
      navigate("/", { replace: true });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-[#08080C]">
      <div className="w-full max-w-sm fade-up">
        <div className="text-center mb-8">
          <div className="w-14 h-14 rounded-full bg-gradient-to-br from-amber-400 to-amber-600 flex items-center justify-center mx-auto mb-4 shadow-lg">
            <Sparkles className="w-6 h-6 text-slate-950" />
          </div>
          <h1 className="text-3xl font-bold gold-text">Avenue Benda</h1>
          <p className="text-xs font-mono uppercase tracking-widest text-amber-400/60 mt-1">Service de Livraison</p>
        </div>
        <form onSubmit={submit} className="glass rounded-2xl p-6 space-y-4">
          <div className="flex items-center gap-2 text-emerald-300/90 bg-emerald-500/10 border border-emerald-500/25 rounded-lg p-2.5">
            <ShieldCheck className="w-4 h-4 shrink-0" />
            <p className="text-[11px]">Accès réservé. Votre compte est créé par l'administrateur. Choisissez votre mot de passe lors de la première connexion.</p>
          </div>
          <div>
            <Label className="text-slate-300 text-xs">Numéro WhatsApp</Label>
            <Input data-testid="client-login-whatsapp" value={whatsapp} onChange={(e) => setWhatsapp(e.target.value)}
              placeholder="+33 6 12 34 56 78" className="bg-[#161926] border-amber-500/20 mt-1 text-slate-100" required />
          </div>
          <div>
            <Label className="text-slate-300 text-xs">Mot de passe</Label>
            <Input data-testid="client-login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              placeholder="Min. 8 caractères" className="bg-[#161926] border-amber-500/20 mt-1 text-slate-100" required />
          </div>
          {error && <p data-testid="client-login-error" className="text-rose-400 text-sm">{error}</p>}
          <Button data-testid="client-login-submit" type="submit" disabled={loading} className="w-full btn-gold rounded-xl py-6">
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Se connecter"}
          </Button>
        </form>
      </div>
    </div>
  );
}
